import { render, staticRenderFns } from "./cmp-user-info.vue?vue&type=template&id=3cb50c98&"
import script from "./cmp-user-info.vue?vue&type=script&lang=ts&"
export * from "./cmp-user-info.vue?vue&type=script&lang=ts&"
import style0 from "./cmp-user-info.vue?vue&type=style&index=0&id=3cb50c98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cmp-user-info.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports